import { render, staticRenderFns } from "./VipRule.vue?vue&type=template&id=59bdaeec&scoped=true&"
import script from "./VipRule.vue?vue&type=script&lang=js&"
export * from "./VipRule.vue?vue&type=script&lang=js&"
import style0 from "./VipRule.vue?vue&type=style&index=0&id=59bdaeec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bdaeec",
  null
  
)

export default component.exports